/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */

export enum priceTypeEnum {
  NONE = 'None',
  BASE = 'Base',
  BOARD = 'Board',
  EARLY_BIRD = 'EarlyBird',
  EXTRA_DAY = 'ExtraDay',
  STAY_PAY = 'StayPay',
  CHILD_REDUCTION = 'ChildReduction',
  DURATION_REDUCTION = 'DurationReduction',
  CHILD_PRICE = 'ChildPrice',
  OCCUPANCY_REDUCTION = 'OccupancyReduction',
  OCCUPANCY_SUPPLEMENT = 'OccupancySupplement',
  BOARD_CHILD_REDUCTION = 'BoardChildReduction',
  BOARD_SUPPLEMENT = 'BoardSupplement',
  SELF_DRIVING_SUPPLEMENT = 'SelfDrivingSupplement',
  GENERAL_SUPPLEMENT = 'GeneralSupplement',
  GENERAL_DISCOUNT = 'GeneralDiscount',
  FUEL_SURCHARGE = 'FuelSurcharge',
  AIR_PASSENGER_DUTY = 'AirPassengerDuty',
  AIRPORT_SURCHARGE = 'AirportSurcharge',
  FLIGHT_SUPPLEMENT = 'FlightSupplement',
  FLIGHT_TAX = 'FlightTax',
  SECURITY_CHARGE = 'SecurityCharge',
  FIRST_MINUTE = 'FirstMinute',
  LAST_MINUTE = 'LastMinute',
  ULTRA_FIRST_MINUTE = 'UltraFirstMinute',
  ULTRA_LAST_MINUTE = 'UltraLastMinute',
  CUSTOM_PRICE_TYPE1 = 'CustomPriceType1',
  CUSTOM_PRICE_TYPE2 = 'CustomPriceType2',
  CUSTOM_PRICE_TYPE3 = 'CustomPriceType3',
  CUSTOM_PRICE_TYPE4 = 'CustomPriceType4',
  CUSTOM_PRICE_TYPE5 = 'CustomPriceType5',
  CUSTOM_PRICE_TYPE6 = 'CustomPriceType6',
  CUSTOM_PRICE_TYPE7 = 'CustomPriceType7',
  CUSTOM_PRICE_TYPE8 = 'CustomPriceType8',
  CUSTOM_PRICE_TYPE9 = 'CustomPriceType9',
  CUSTOM_PRICE_TYPE10 = 'CustomPriceType10',
  CUSTOM_PRICE_TYPE11 = 'CustomPriceType11',
  CUSTOM_PRICE_TYPE12 = 'CustomPriceType12',
  CUSTOM_PRICE_TYPE13 = 'CustomPriceType13',
  CUSTOM_PRICE_TYPE14 = 'CustomPriceType14',
  CUSTOM_PRICE_TYPE15 = 'CustomPriceType15',
  CUSTOM_PRICE_TYPE16 = 'CustomPriceType16',
  CUSTOM_PRICE_TYPE17 = 'CustomPriceType17',
  CUSTOM_PRICE_TYPE18 = 'CustomPriceType18',
  CUSTOM_PRICE_TYPE19 = 'CustomPriceType19',
  CUSTOM_PRICE_TYPE20 = 'CustomPriceType20',
  CUSTOM_PRICE_TYPE21 = 'CustomPriceType21',
  CUSTOM_PRICE_TYPE22 = 'CustomPriceType22',
  CUSTOM_PRICE_TYPE23 = 'CustomPriceType23',
  CUSTOM_PRICE_TYPE24 = 'CustomPriceType24',
  CUSTOM_PRICE_TYPE25 = 'CustomPriceType25',
  CUSTOM_PRICE_TYPE26 = 'CustomPriceType26',
  CUSTOM_PRICE_TYPE27 = 'CustomPriceType27',
  CUSTOM_PRICE_TYPE28 = 'CustomPriceType28',
  CUSTOM_PRICE_TYPE29 = 'CustomPriceType29',
  CUSTOM_PRICE_TYPE30 = 'CustomPriceType30',
}
